import { createFileRoute } from '@tanstack/react-router'
import DocumentosDigitaisGeradoDetalhePage from '@/pages/dashboard/documentos-digitais-gerado-detalhe-page'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/documentos-digitais/gerados/$documentoId/',
)({
  component: DocumentosDigitaisGeradoDetalhePage,
})
